<template>
  <div class="address-nominatim">
    <e-suggestion
      :inputStyle="inputStyle"
      :suggestionEndpoint="suggestionEndpoint"
      :transformSuggestions="transformSuggestions"
      :name="name"
      :model="model"
      :required="required"
      :disabled="disabled"
      @selectItem="selectItem"
      nameKey="display_name"
      valueKey="osm_id"
      :minSuggestLen="1"
      :suggestDelay="100"
      :placeholder="placeholder"
      ref="input"
      :transformRequest="transformRequest()"
    ></e-suggestion>
  </div>
</template>

<script>
  import {NOMINATIM_API_URL, NOMINATIM_COUNTRY_CODES} from "../../config/config"
  import {NOMINATIM_ACCEPT_LANGUAGE} from "../../config/locale"
  import {AddressModel} from "./AddressModel";

  // data-* attributes used for debug
  export default {
    name: 'address-nominatim',
    data () {
      return {
        error: null
      }
    },
    props: {
      inputStyle: {
        type: Object,
        default: () => {}
      },
      onChangeValidation: {
        type: Boolean,
        default: false
      },
      formValidator: null,
      model: {
        type: Object,
        required: true
      },
      tabView: {
        type: String,
        default: null
      },
      name: {
        type: String,
        default: null,
        required: true
      },
      validateAlias: {
        type: String,
        default: null
      },
      required: {
        type: Boolean,
        default: false
      },
      modalVariableName: {
        type: String,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: null
      },
      inputType: {
        type: String,
        default: 'text'
      },
      mask: {
        type: String,
        default: null
      },
      onValidate: {
        type: Function,
        default: (obj) => obj
      },
      addressData: {
        type: Object,
        required: true,
        default: function () {
          return {}
        }
      },
      addressIdFieldName: {
        type: String,
        default: 'address_id'
      },
      houseFiasFieldName: {
        type: String,
        default: null
      },
      geoFields: {
        type: Array
      },
      callbacks: {
        type: Object,
        default: () => ({
          onSuggestionsFetch: () => void null,
          onSuggestMount: () => void null
        })
      }
    },
    computed: {
      getPlaceholder () {
        if (this.placeholder === null) {
          return ''
        }
        return this.placeholder
      },
      hasError () {
        if (this.error) {
          return true
        }
        return false
      }
    },
    created () {
      if (this.formValidator) {
        this.formValidator.subscribeInput(this)
      }
    },
    destroyed () {
      if (this.formValidator) {
        this.formValidator.unsubscribeInput(this)
      }
    },
    methods: {
      getElement () {
        return this.$refs.input.getElement()
      },
      transformRequest () {
        return [function (data, headers) {
          delete headers.Authorization
          return data
        }]
      },
      selectItem (raw) {
        const data = new AddressModel()
        data.value = raw.display_name
        data.raw = raw
        data.data.setNominatim(raw)
        data.addressIdFieldName = this.addressIdFieldName
        data.houseFiasFieldName = this.houseFiasFieldName

        this.addressData[this.name] = data
        this.model[this.name] = data.value

        if (this.geoFields) {
          this.model[this.geoFields[0]] = data.data.geo_lat
          this.model[this.geoFields[1]] = data.data.geo_lon
        }

        this.$emit('selectItem', data)
      },
      suggestionEndpoint (ctx, q) {
        let url = `${NOMINATIM_API_URL}?format=json&q=${q}&addressdetails=1&countrycodes=${NOMINATIM_COUNTRY_CODES}`
        if (NOMINATIM_ACCEPT_LANGUAGE) {
          url += `&accept-language=${NOMINATIM_ACCEPT_LANGUAGE}`
        }
        return url
      },
      transformSuggestions (ctx, data) {
        console.log('transformSuggestions', data)
        return data.map(v => {
          const {address: {road, village, city, state, house_number}} = v
          const parts = [state, village, city, road, house_number].filter(v => v)
          v.display_name = parts.join(', ')
          return v
        }).filter(v => v.display_name)
      },
      validate () {
        let msg = ''
        if (this.required && !this.model[this.name]) {
          msg += 'Укажите адрес'
        }

        return this.onValidate({
          error: msg,
          tabView: this.tabView,
          name: this.name,
          modalVariableName: this.modalVariableName,
          el: this.getElement(),
          model: this.model
        })
      }
    }
  }
</script>
